import { Edit } from '@mui/icons-material';
import { ListItemIcon, MenuItem } from '@mui/material';
import { FC } from 'react';

type SubroutinePasteMenuItemProps = {
  contextType: 'folder' | 'subroutine';
  onSubmit: () => void;
};

const SubroutinePasteMenuItem: FC<SubroutinePasteMenuItemProps> = (props) => {
  return (
    <MenuItem onClick={(e) => props.onSubmit()}>
      <ListItemIcon>
        <Edit fontSize='small' />
      </ListItemIcon>
      Paste {props.contextType === 'folder' ? 'Folder' : 'Subroutine'}
    </MenuItem>
  );
};

export default SubroutinePasteMenuItem;
